import { lazy } from "react";
import Constants from "expo-constants";

const CustomerAppProvider = lazy(
  () => import("./src/customer/navigation/AppProvider")
);

const MerchantAppProvider = lazy(
  () => import("./src/merchant/navigation/AppProvider")
);

export default function AppProvider() {
  const extras = Constants.expoConfig?.extra;
  const client = extras?.client || process.env.CLIENT;
  
  return (
    <>
      {client === "merchant" ? (
        <MerchantAppProvider />
      ) : (
        <CustomerAppProvider />
      )}
    </>
  );
}
